import React, { useContext, useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { AssetStore } from "../../../../../assets/AssetsStore";
import DataBox from "../../../../ManagePrescriptionComponents/DataBox/DataBox";
import DataBoxNote from "../../../../ManagePrescriptionComponents/DataBoxNote/DataBoxNote";
import RecentSymptoms from "./RecentSymptoms/RecentSymptoms";
import styles from "./index.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  ManageDataInPrescription,
  updateManagePrescriptionSubmissionData,
} from "../../../../../actions/ManagePrescriptionAction";
import ExaminationBox from "../../../../ManagePrescriptionComponents/ExaminationBox/ExaminationBox";
import {
  getLabFindings,
  getMedicalHistory,
  getProvisionalList,
  getSymptomList,
  saveMedicalHistory,
  saveProvision,
} from "../../../../../reducers/symptom.api";
import { PrescriprionContext } from "../../../PrintPrescription";

function ConsultationNotes() {
  const dispatch = useDispatch();

  const [symptomData, setSymptomData] = useState([]);
  const [symptomDetailedData, setSymptomDetailedData] = useState([]);
  const [provisionalData, setProvisionalData] = useState([]);
  const [labDetailData, setLabDetailData] = useState([]);
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);

  const [medicalHistory, setMedicalHistory] = useState([]);

  const { initialData, submissionData } = useSelector(
    (state) => state.managePrescription
  );
  // console.log(initialData);

  const initialMedicalHistory = initialData?.medicalHistory;
  const selectedMedicalHistory = submissionData?.medicalHistory;

  const [initialExamination, setInitialExamination] = useState([]);
  const selectedExamination = submissionData?.examinations;

  const initialDiagnosis = initialData?.diagnosis;
  const selectedDiagnosis = submissionData?.diagnosis;

  const isSelected = (data, name) => {
    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);
      return res && res.length > 0;
    }
  };

  const getComponent = (param_data, index) => {
    switch (param_data?.name) {
      case data[0]?.name:
        return (
          <RecentSymptoms
            index={index}
            callFunction={() => getSymptomLists()}
            haveNote={param_data?.haveNote}
            noteValue={param_data?.noteValue}
            onChangeNote={param_data?.onChangeNote}
            data={param_data?.data}
            name={param_data?.text}
            addTitle={param_data?.addTitle}
            detailedData={symptomDetailedData}
            title={param_data?.title}
          />
        );
      case data[2]?.name:
        return (
          <DataBoxNote
            haveNote={param_data?.haveNote}
            noteValue={param_data?.noteValue}
            onChangeNote={param_data?.onChangeNote}
            // name={param_data?.text}
            title={param_data?.title}
          />
        );
      case data[3]?.name:
        return (
          <ExaminationBox
            toggle={param_data?.toggle}
            selectedData={param_data?.selectedData}
            handleAdd={param_data?.handleAdd}
            handleSearch={param_data?.handleSearch}
            initialData={param_data?.data}
            data={param_data?.data}
            name={param_data?.text}
            addTitle={param_data?.addTitle}
            haveNote={param_data?.haveNote}
            callBackFunction={getLabFindingsData}
            detailedData={labDetailData}
          />
        );
      case data[4]?.name:
        return (
          <DataBoxNote
            haveNote={param_data?.haveNote}
            noteValue={param_data?.noteValue}
            onChangeNote={param_data?.onChangeNote}
            // name={param_data?.text}
            title={param_data?.title}
          />
        );
      default:
        return (
          <DataBox
            haveCovidData={param_data?.haveCovidData}
            noteValue={param_data?.noteValue}
            onChangeNote={param_data?.onChangeNote}
            haveNote={param_data?.haveNote}
            toggle={param_data?.toggle}
            selectedData={param_data?.selectedData}
            handleAdd={param_data?.handleAdd}
            handleSearch={param_data?.handleSearch}
            initialData={param_data?.data}
            data={param_data?.data}
            name={param_data?.text}
            addTitle={param_data?.addTitle}
            title={param_data?.title}
          />
        );
    }
  };

  const handleSearchMedicalHistory = (value) => {
    let _item = initialMedicalHistory.filter((e) => e.name == value)[0];
    let _isSelected = selectedMedicalHistory.filter((e) => e.name == value)[0];

    if (!_isSelected) {
      toggleMedicalHistory(_item);
    }
  };
  const handleAddMedicalHistory = (name) => {
    saveMedicalHistory(name, getMedicalHistoryList);
    dispatch(
      ManageDataInPrescription({
        context: "Add",
        item: "medical",
        payload: name,
        existing: initialMedicalHistory || [],
      })
    );
    toggleMedicalHistory(name);
  };
  const toggleMedicalHistory = (name) => {
    dispatch(
      ManageDataInPrescription({
        context: "Toggle",
        item: "medical",
        payload: name,
        existing: selectedMedicalHistory || [],
        initial: initialMedicalHistory,
      })
    );
  };

  const onChangeNoteMedicalHistory = (e) => {
    let { value } = e?.target;
    handleWholeData("medicalHistoryNote", value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        medical_history_note: value,
      })
    );
  };

  const onChangeNoteSymptoms = (e) => {
    let { value } = e?.target;  
    //console.debug("Input value:", value);
    handleWholeData("symptomsNote", value);
    //console.debug("State before update:", value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        symptoms_note: value,
      })
    );
    //console.debug("State after update:", value);
  };

  const onChangeNoteFamilyHistory = (e) => {
    let { value } = e?.target;
    handleWholeData("familyHistoryNote", value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        family_history_note: value,
      })
    );
  };

  const onChangeNoteDiagnosticHistory = (e) => {
    let { value } = e?.target;
    handleWholeData("diagnosticNote", value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        diagnostic_note: value,
      })
    );
  };

  const onChangeNoteDiagnosisHistory = (e) => {
    let { value } = e?.target;
    handleWholeData("diagnosisNote", value);
    dispatch(
      updateManagePrescriptionSubmissionData({
        diagnosis_note: value,
      })
    );
  };

  const handleSearchExamination = (value) => {
    let _item = initialExamination.filter((e) => e.name == value?.name)[0];

    if (_item) {
      if (!isSelected(selectedExamination, value)) {
        dispatch(
          ManageDataInPrescription({
            context: "Toggle",
            item: "examination",
            payload: value,
            existing: selectedExamination,
            initial: initialExamination,
          })
        );
      }
    } else {
      dispatch(
        ManageDataInPrescription({
          context: "Add",
          item: "examination",
          payload: value,
          existing: selectedExamination,
        })
      );
    }
  };
  const handleAddExamination = (name) => {
    dispatch(
      ManageDataInPrescription({
        context: "Add",
        item: "examination",
        payload: name,
        existing: initialExamination,
      })
    );
    toggleExamination(name);
  };
  const toggleExamination = (name) => {
    dispatch(
      ManageDataInPrescription({
        context: "Toggle",
        item: "examination",
        payload: name,
        existing: selectedExamination,
        initial: initialExamination,
      })
    );
  };

  const handleSearchDiagnosis = (value) => {
    let _item = initialDiagnosis.filter((e) => e.name == value)[0];
    let _isSelected = selectedDiagnosis.filter((e) => e.name == value)[0];

    if (!_isSelected) {
      dispatch(
        ManageDataInPrescription({
          context: "Toggle",
          item: "diagnosis",
          payload: _item,
          existing: selectedDiagnosis,
          initial: initialDiagnosis,
        })
      );
    }
  };
  const handleAddDiagnosis = (name) => {
    saveProvision(name, getProvisionalDiagonosis);
    dispatch(
      ManageDataInPrescription({
        context: "Add",
        item: "diagnosis",
        payload: name,
        existing: initialDiagnosis,
      })
    );
    toggleDiagnosis(name);
  };
  const toggleDiagnosis = (name) => {
    dispatch(
      ManageDataInPrescription({
        context: "Toggle",
        item: "diagnosis",
        payload: name,
        existing: selectedDiagnosis,
        initial: initialDiagnosis,
      })
    );
  };

  const getSymptomLists = () => {
    getSymptomList((res) => {
      setSymptomDetailedData(res);
      setSymptomData(
        res.map((item) => {
          return {
            name: item.symptomName,
          };
        })
      );
    });
  };

  const getMedicalHistoryList = () => {
    getMedicalHistory((res) => {
      setMedicalHistory(
        res.map((item) => {
          return {
            name: item.medicalHistoryName,
          };
        })
      );
    });
  };

  const getProvisionalDiagonosis = () => {
    getProvisionalList("84743113", (res) => {
      setProvisionalData(
        res.map((item) => {
          return {
            name: item.provisionName,
          };
        })
      );
    });
  };

  const getLabFindingsData = () => {
    getLabFindings("84743113", (res) => {
      setLabDetailData(res);
      setInitialExamination(
        res.map((item) => {
          return {
            name: item.labTestName,
          };
        })
      );
    });
  };

  useEffect(() => {
    getSymptomLists();
    getMedicalHistoryList();
    getProvisionalDiagonosis();
    getLabFindingsData();
  }, []);

  const diagnosis = [
    "Viral Fever",
    "Allergy Bronchitis",
    "Active febrile illness",
    "WALRI",
    "LRTI Lower respiration",
  ];
  const data = [
    {
      name: "Symptoms",
      icon: AssetStore.managePrescription.symptom,
      data: symptomData,
      text: "Recent Symptoms",
      addTitle: "Add new symptom",
      haveNote: true,
      noteValue: wholeData?.symptomsNote,
      onChangeNote: onChangeNoteSymptoms,
      haveNote: true,
      ismandatory:true,
    },
    {
      name: "Medical History",
      haveCovidData: true,
      icon: AssetStore.managePrescription.med_history,
      data: medicalHistory,
      selectedData: selectedMedicalHistory,
      text: "Select Medical Problem",
      addTitle: "Add new medical problem",
      handleSearch: handleSearchMedicalHistory,
      handleAdd: handleAddMedicalHistory,
      toggle: toggleMedicalHistory,
      haveNote: true,
      onChangeNote: onChangeNoteMedicalHistory,
      noteValue: wholeData?.medicalHistoryNote,
      title: "medicalHistory",
      ismandatory:true,
    },
    {
      name: "Family History",
      icon: AssetStore.managePrescription.fam_history,
      onChangeNote: onChangeNoteFamilyHistory,
      noteValue: wholeData?.familyHistoryNote,
      haveNote: true,
    },
    {
      name: "Examination",
      icon: AssetStore.managePrescription.examination,
      data: initialExamination,
      selectedData: selectedExamination,
      handleSearch: handleSearchExamination,
      handleAdd: handleAddExamination,
      toggle: toggleExamination,
      text: "Past Findings",
      addTitle: "Add new Examination",
      // ismandatory:true,
    },
    {
      name: "Diagnostic Reports",
      icon: AssetStore.managePrescription.diagostic_report,
      onChangeNote: onChangeNoteDiagnosticHistory,
      noteValue: wholeData?.diagnosticNote,
      haveNote: true,
    },
    {
      name: "Provisional / Final Diagnosis",
      icon: AssetStore.managePrescription.diagnosis,
      data: provisionalData,
      selectedData: selectedDiagnosis,
      handleSearch: handleSearchDiagnosis,
      handleAdd: handleAddDiagnosis,
      toggle: toggleDiagnosis,
      text: "Past Diagnosis",
      title: "Diagnosis",
      ismandatory:true,
      haveNote: true,
      onChangeNote: onChangeNoteDiagnosisHistory,
      noteValue: wholeData?.diagnosisNote,
      ismandatory:true,
    },
  ];

  console.log("data", data);
  console.log("submissionData");
  return (
    <div className={styles.consultationNote}>
      <Accordion
        className={styles.accordion}
        alwaysOpen
        defaultActiveKey={[0, 1, 2, 3]}
      >
        {data.map((each, key) => {
          return (
            <div key={key}>
              <div className={styles.devider}>&nbsp;</div>
              <Accordion.Item
                className={
                  key >= data.length - 1 && styles.accordion_last_item_wrap
                }
                key={key}
                eventKey={key}
              >
                <Accordion.Header>
                  <span className={styles.accordion_header}>
                    <div className={styles.icon}>
                      <img src={each.icon} alt="" />
                    </div>
                    <span className={styles.accordion_header_title}>
                      {each.name} {each.ismandatory ? <span style={{color:"red"}}>*</span>:""}
                    </span>
                  </span>
                </Accordion.Header>

                <Accordion.Body>
                  {getComponent(each, key)}

                  {/* <DataBox
                                            data={each?.data}
                                            name={each?.name}
                                            haveNote={each?.haveNote}
                                        /> */}
                </Accordion.Body>
              </Accordion.Item>

              <div className={styles.devider}>&nbsp;</div>
            </div>
          );
        })}
      </Accordion>
    </div>
  );
}

export default ConsultationNotes;
